import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Modal from '../ui/Modal';

/** Buy page deep-link that scrolls to the Add-ons section. */
const CONTENT_MASTER_BUY_ADDON_PATH = '/licenses/buy?plugin=content_master&scroll=addons';

interface ContentMasterAddonRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Shown when a marketplace-listing feature is used without an active
 * `content_master_addon_marketplace_listing` subscription (e.g. selecting a
 * Marktplatz channel in the product search). Mirrors the subscription
 * insufficient (Pro upgrade) modal; the CTA routes to the buy page and
 * scrolls to the Add-ons section.
 */
const ContentMasterAddonRequiredModal: React.FC<ContentMasterAddonRequiredModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('cm_addon_marketplace_modal_title')}
      isCentered
      hideCloseButton
      className="content-master-confirm-modal content-master-confirm-modal--subscription"
    >
      <div className="content-master-confirm-modal__layout">
        <div className="content-master-confirm-modal__text">
          <p>{t('cm_addon_marketplace_modal_body')}</p>
        </div>
        <div className="content-master-confirm-modal__illustration" aria-hidden />
      </div>
      <div className="content-master-confirm-modal__buttons">
        <button
          type="button"
          className="btn btn-secondary content-master-confirm-modal__btn-secondary"
          onClick={onClose}
        >
          {t('cancelText')}
        </button>
        <button
          type="button"
          className="btn btn-primary content-master-confirm-modal__btn-primary"
          onClick={() => {
            onClose();
            navigate(CONTENT_MASTER_BUY_ADDON_PATH);
          }}
        >
          {t('cm_addon_marketplace_cta')}
        </button>
      </div>
    </Modal>
  );
};

export default ContentMasterAddonRequiredModal;
